import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * The header profile dropdown, redesigned to match the nf-panels menu language (rounded card,
 * avatar header, hover-tinted rows with leading glyphs). Presentational: the header owns the
 * avatar trigger and open state, passes the identity in, and acts on (logout)/(menuClose).
 */
@Component({
    selector: 'netfoundry-ui-profile-menu',
    standalone: true,
    imports: [CommonModule, RouterModule, MatTooltipModule],
    templateUrl: './profile-menu.component.html',
    styleUrls: ['./profile-menu.component.scss'],
})
export class ProfileMenuComponent {
    /** Display name (the profile nick); shown verbatim. */
    @Input() name = '';
    /** Avatar image URL; falls back to a monogram when absent. */
    @Input() photo?: string;
    /** When billing is invalid the profile/settings links are hidden (only logout remains). */
    @Input() billingInvalid = false;

    /** Current theme preference: 'auto' (System) | 'false' (Light) | 'true' (Dark). */
    @Input() theme = 'auto';
    /** Whether beta features are currently on (support-only). */
    @Input() betaEnabled = false;

    @Output() logout = new EventEmitter<void>();
    /** Ask the header to close the popup (after a navigation or logout). */
    @Output() menuClose = new EventEmitter<void>();
    /** Quick theme change from the menu; the header persists + applies it. */
    @Output() themeChange = new EventEmitter<string>();
    /** Toggle beta features; the header flips + persists the flag. */
    @Output() betaToggle = new EventEmitter<void>();

    /** First letter of the name, for the monogram fallback when there's no photo. */
    get initial(): string {
        return (this.name || '?').trim().charAt(0).toUpperCase();
    }

    pickTheme(value: string): void {
        this.themeChange.emit(value);
    }

    /** Toggle beta without closing the menu (stop the click reaching the header's toggle). */
    onBetaClick(event: Event): void {
        event.stopPropagation();
        this.betaToggle.emit();
    }
}
